import { useEffect, useRef, useState } from "react";

import { getUserAPI } from "api/IdentityServiceAPI";
import { setAppuserInfo, setuserprofileInfo, setLoggedIn, setAppId, setProfile,setInitialAPIload } from "store/slice/HeaderSlice";
import Cookies from "js-cookie";

import { getListAPI as getProductList } from 'components/product/ProductAPI';
import { getListAPI as getCategoryList } from 'components/category/CategoryAPI';
import { getListAPI as getProductcategoryList } from 'components/productcategory/ProductcategoryAPI';
import { getListAPI as getCustomerList } from 'components/customer/CustomerAPI';
import { getListAPI as getActionList } from '../api/ActionAPI';

import { useDispatch,useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setActionList,setProductList,setCategoryList,setProductcategoryList,setCustomerList,setMlmuserOnboardModal,setMlmuserAddUserModal,setWabaChoiceDialogOpen } from 'store/slice/DmpSlice';
import { setMessage,openLoginModal, refreshUserProfile} from "store/slice/HeaderSlice";
import { setInviteeMobileNumber } from "store/slice/EcomSlice";
import { setPartnershipInitiationMode, setSelectedBottomMenu, setSelectedTab } from "store/slice/EcomSlice";
import { setPageName } from "store/slice/AppSlice";
import { getJWTByWabaMsgInfoAPI, updateAppRefreshAPI, updateLastLoginAPI } from "api/CorePlatformserviceWebServices";
import { Card, CardActionArea, CardContent, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import CloseIcon from '@mui/icons-material/Close';

export default function DmpStoreLoader() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedAction, setSelectedAction] = useState(null);
    const hasOpenedPartnerMenuRef = useRef(false);
    const getActionListSuccess = (list) =>{dispatch(setActionList(list));}
    const {isLoggedIn, userprofileInfo,refreshUserProfile} = useSelector((state)=>state.headerslice)
    const {wabaChoiceDialogOpen} = useSelector((state)=>state.dmpslice);

    
const getProductListSuccess = (list) =>{dispatch(setProductList(list));}
const getCategoryListSuccess = (list) =>{dispatch(setCategoryList(list));}
const getProductcategoryListSuccess = (list) =>{dispatch(setProductcategoryList(list));}
const getCustomerListSuccess = (list) =>{dispatch(setCustomerList(list));}

const getLoginId= ()=>{
    if (!userprofileInfo.email) return "";
    return userprofileInfo.email && userprofileInfo.email.split('@')[0];
}

    const removeQueryParamsFromUrl = () => {
        window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
    }

    const handleWabaJwtSuccess = (response) => {
        if (!response?.accesstoken) {
            navigate("/");
            return;
        }

        localStorage.setItem("JWT", response.accesstoken);
        dispatch(setAppuserInfo(response.appuserInfo || {}));
        dispatch(setuserprofileInfo(response.userprofileInfo || {}));
        dispatch(setLoggedIn(true));
        updateLastLoginAPI({}, () => {}, () => {});
        removeQueryParamsFromUrl();
        dispatch(setWabaChoiceDialogOpen(true));
    }

    const handleWabaJwtFailure = (errMsg) => {
        console.log('Failed to authenticate from WABA link => ' + errMsg);
        navigate("/");
    }

    const attemptWabaJwtLoginFromQuery = () => {
        if (window.location.pathname !== "/") return false;

        const searchParams = new URLSearchParams(window.location.search);
        const reqid = searchParams.get("reqid");
        const code = searchParams.get("code");

        if (!reqid || !code) return false;

        const wabareqId = Number(reqid);
        const accessCode = Number(code);

        if (Number.isNaN(wabareqId) || Number.isNaN(accessCode)) {
            return false;
        }

        getJWTByWabaMsgInfoAPI(
            { wabareqId, accessCode },
            handleWabaJwtSuccess,
            handleWabaJwtFailure
        );

        return true;
    }

    const closeWabaChoiceDialog = () => {
        setSelectedAction(null);
        dispatch(setWabaChoiceDialogOpen(false));
    }

    const selectChoice = (choice, handler) => {
        setSelectedAction(choice);
        handler();
    }

    const handleBuyProduct = () => {
        closeWabaChoiceDialog();
    }

    const handleAddMember = () => {
        dispatch(setPartnershipInitiationMode(false));
        dispatch(setSelectedBottomMenu("PARTNER"));
        dispatch(setSelectedTab("MY-TEAM"));
        dispatch(setMlmuserAddUserModal(true));
        closeWabaChoiceDialog();
        navigate("/");
    }

    const handleViewCreditStatement = () => {
        dispatch(setPartnershipInitiationMode(false));
        dispatch(setSelectedBottomMenu("PARTNER"));
        dispatch(setSelectedTab("CREDIT"));
        closeWabaChoiceDialog();
        navigate("/");
    }

    // Extract page name from URL hash
    const extractPageNameFromHash = () => {
        const hash = window.location.hash;
        if (hash && hash.length > 1) {
            const pageName = hash.substring(1); // Remove the # symbol
            dispatch(setPageName(pageName));
        }
    }

    /***   Load User profile if JWT is found otherwise Redirect to Login  */
    const storeInviteeMobileNumber = () =>{
        let url = window.location.href;
        let indexOfKey = url.lastIndexOf('?inviteelogin=');
        //if (indexOfKey==-1 || url.length<indexOfKey+14)  return;
        if (indexOfKey==-1)  return;
        const inviteeMobileNumber = url.substring(url.lastIndexOf('?inviteelogin=')+14, url.lastIndexOf('?inviteelogin=')+24)
        dispatch(setInviteeMobileNumber(inviteeMobileNumber));
        
        //dispatch(openLoginModal(true));
        // if (getLoginId()!==inviteeMobileNumber){
        //     localStorage.removeItem("JWT");
        //     Cookies.remove("anonymousId");
        // }
        dispatch(setMlmuserOnboardModal(true));

    }
    useEffect(() => {
        
        // Extract page name from URL hash on component load
        extractPageNameFromHash();
        
        storeInviteeMobileNumber();
        if (attemptWabaJwtLoginFromQuery()) return;
        if (localStorage.getItem("JWT") !== null) {
                //getUserAPI(loadUserSuccessCallBack, loadUserFailureCallBack);
                updateAppRefreshAPI({}, ()=>{}, ()=>{});
        } else {
            navigate("/");
        }
    }, [])
    useEffect(()=>{
        if (userprofileInfo && localStorage.getItem("JWT") !== null)
        getUserAPI(loadUserSuccessCallBack, loadUserFailureCallBack);
    },[refreshUserProfile, userprofileInfo.email])

    useEffect(() => {
        if (hasOpenedPartnerMenuRef.current) return;
        if (!isLoggedIn || !userprofileInfo?.rolename) return;
        if (userprofileInfo.rolename === 'MLM_MEMBER') {
            dispatch(setWabaChoiceDialogOpen(false));
            return;
        }
        if (userprofileInfo.rolename !== 'MLM_PARTNER') return;
        if (wabaChoiceDialogOpen) return;

        hasOpenedPartnerMenuRef.current = true;
        dispatch(setWabaChoiceDialogOpen(true));
    }, [dispatch, isLoggedIn, userprofileInfo?.rolename, wabaChoiceDialogOpen]);

    const loadUserSuccessCallBack = (response) => {
        if (response.userprofileInfo==undefined || response.appuserInfo==undefined){
            navigate('/');
            return;
        } 
        dispatch(setMessage(response.userprofileInfo.businessname));
        dispatch(setAppuserInfo(response.appuserInfo));
        dispatch(setuserprofileInfo(response.userprofileInfo));

        console.log('response.userprofileInfo.rolename==>'+response.userprofileInfo.rolename);
        if (response.userprofileInfo.rolename!=='MLM_CUSTOMER')
            dispatch(setLoggedIn(true));
    }
    const loadUserFailureCallBack = (response) => {
        navigate("/");

    }
    /* -----------  */

    /***   On User Profile Load, fetch all BOs    */
    useEffect(() => {
        if (isLoggedIn && (userprofileInfo!==null && userprofileInfo.username!==undefined)){
            loadBOs();
        }
    }, [userprofileInfo?.email]);

    const loadBOs = ()=>{
    //getActionList(()=>{}, getActionListSuccess);

        
    //getProductList(()=>{}, getProductListSuccess);
    // getCategoryList(()=>{}, getCategoryListSuccess);
    // getProductcategoryList(()=>{}, getProductcategoryListSuccess);
    // getCustomerList(()=>{}, getCustomerListSuccess);
         
    }

    return (
        <>
        <Dialog
            open={wabaChoiceDialogOpen}
            onClose={closeWabaChoiceDialog}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 5,
                    overflow: 'hidden',
                    background: 'linear-gradient(180deg, #ffffff 0%, #f1f6ff 100%)',
                    border: '1px solid rgba(0, 58, 140, 0.15)',
                    boxShadow: '0 24px 70px rgba(0, 31, 91, 0.28)',
                }
            }}
        >
            <DialogTitle sx={{ pb: 1, textAlign: 'center', position: 'relative' }}>
                <IconButton
                    aria-label="close"
                    onClick={closeWabaChoiceDialog}
                    sx={{ position: 'absolute', right: 12, top: 12, color: 'text.secondary' }}
                >
                    <CloseIcon />
                </IconButton>
                <Typography variant="h5" sx={{ fontWeight: 800, color: 'primary.darker' }}>
                    Choose an action
                </Typography>
            </DialogTitle>
            <DialogContent dividers sx={{ background: 'linear-gradient(180deg, #eaf1ff 0%, #ffffff 100%)', px: 2, pb: 2 }}>
                <Grid container spacing={1.5}>
                    <Grid item xs={12} sm={4}>
                        <Card
                            elevation={0}
                            sx={{
                                borderRadius: 3,
                                height: '100%',
                                border: selectedAction === 'BUY' ? '2px solid' : '1px solid',
                                borderColor: selectedAction === 'BUY' ? 'primary.main' : 'rgba(0, 58, 140, 0.18)',
                                background: selectedAction === 'BUY' ? 'linear-gradient(180deg, #ffffff 0%, #eaf2ff 100%)' : '#ffffff',
                                boxShadow: selectedAction === 'BUY' ? '0 16px 30px rgba(0, 58, 140, 0.16)' : '0 8px 18px rgba(0, 31, 91, 0.08)',
                            }}
                        >
                            <CardActionArea onClick={() => selectChoice('BUY', handleBuyProduct)} sx={{ height: '100%' }}>
                                <CardContent sx={{ textAlign: 'center', py: 3 }}>
                                    <ShoppingBagOutlinedIcon sx={{ fontSize: 38, color: 'primary.dark', mb: 1 }} />
                                    <Typography variant="subtitle1" sx={{ fontWeight: 800, color: 'primary.darker' }}>
                                        Buy Product
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Card
                            elevation={0}
                            sx={{
                                borderRadius: 3,
                                height: '100%',
                                border: selectedAction === 'ADD_MEMBER' ? '2px solid' : '1px solid',
                                borderColor: selectedAction === 'ADD_MEMBER' ? 'primary.main' : 'rgba(0, 58, 140, 0.18)',
                                background: selectedAction === 'ADD_MEMBER' ? 'linear-gradient(180deg, #ffffff 0%, #eaf2ff 100%)' : '#ffffff',
                                boxShadow: selectedAction === 'ADD_MEMBER' ? '0 16px 30px rgba(0, 58, 140, 0.16)' : '0 8px 18px rgba(0, 31, 91, 0.08)',
                            }}
                        >
                            <CardActionArea onClick={() => selectChoice('ADD_MEMBER', handleAddMember)} sx={{ height: '100%' }}>
                                <CardContent sx={{ textAlign: 'center', py: 3 }}>
                                    <PersonAddAlt1OutlinedIcon sx={{ fontSize: 38, color: 'primary.dark', mb: 1 }} />
                                    <Typography variant="subtitle1" sx={{ fontWeight: 800, color: 'primary.darker' }}>
                                        Add Member
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Card
                            elevation={0}
                            sx={{
                                borderRadius: 3,
                                height: '100%',
                                border: selectedAction === 'CREDIT' ? '2px solid' : '1px solid',
                                borderColor: selectedAction === 'CREDIT' ? 'primary.main' : 'rgba(0, 58, 140, 0.18)',
                                background: selectedAction === 'CREDIT' ? 'linear-gradient(180deg, #ffffff 0%, #eaf2ff 100%)' : '#ffffff',
                                boxShadow: selectedAction === 'CREDIT' ? '0 16px 30px rgba(0, 58, 140, 0.16)' : '0 8px 18px rgba(0, 31, 91, 0.08)',
                            }}
                        >
                            <CardActionArea onClick={() => selectChoice('CREDIT', handleViewCreditStatement)} sx={{ height: '100%' }}>
                                <CardContent sx={{ textAlign: 'center', py: 3 }}>
                                    <ReceiptLongOutlinedIcon sx={{ fontSize: 38, color: 'primary.dark', mb: 1 }} />
                                    <Typography variant="subtitle1" sx={{ fontWeight: 800, color: 'primary.darker' }}>
                                        Credit Summary
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
        </>
    )
}
